import React, { createContext, useContext, useState } from 'react';

const PermissionContext = createContext();

export const usePermissions = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionProvider');
  }
  return context;
};

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [userRole, setUserRole] = useState(null);

  const updatePermissions = (newPermissions, role) => {
    setPermissions(newPermissions);
    setUserRole(role);
  };

  const clearPermissions = () => {
    setPermissions([]);
    setUserRole(null);
  };

  const hasPermission = (permissionName) => {
    return permissions.includes(permissionName);
  };

  const value = {
    permissions,
    userRole,
    updatePermissions,
    clearPermissions,
    hasPermission,
  };

  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  );
}; 